import { createSelector } from 'reselect';
import { initialStateClients } from '../store/models/clients';

const clientsSelector = state => state.clients || initialStateClients;

const makeSelectData = () => createSelector(clientsSelector, globalState => globalState.data);

const makeSelectedClient = () =>
  createSelector(clientsSelector, globalState => globalState.selectedClient);

const makeSelectClient = () => createSelector(clientsSelector, globalState => globalState.cid);

const makeSelectSubscription = () =>
  createSelector(clientsSelector, globalState => globalState.sub);

const makeSelectClientApps = () => createSelector(clientsSelector, globalState => globalState.apps);

const makeSelectLoading = () => createSelector(clientsSelector, globalState => globalState.loading);

const makeSelectUsers = () => createSelector(clientsSelector, globalState => globalState.users);

const makeSelectClients = () => createSelector(clientsSelector, globalState => globalState.clients);

const makeSelectAuditLogs = () =>
  createSelector(clientsSelector, globalState => globalState.auditLogs);

const makeSelectAppRoles = () =>
  createSelector(clientsSelector, globalState => globalState.approles);

export {
  makeSelectData,
  makeSelectedClient,
  makeSelectClient,
  makeSelectSubscription,
  makeSelectClientApps,
  makeSelectLoading,
  makeSelectUsers,
  makeSelectClients,
  makeSelectAppRoles,
  makeSelectAuditLogs,
};
